import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { WHATSAPP_URL } from '../constants/images';
export function CtaBanner() {
  return <section className="py-20 md:py-28 bg-brand-navy relative overflow-hidden" data-id="element-127">
      <motion.div animate={{
      x: [0, 100, 0],
      y: [0, 50, 0]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-brand-green opacity-10 blur-3xl" data-id="element-128" />
      <motion.div animate={{
      x: [0, -100, 0],
      y: [0, -50, 0]
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-brand-gold opacity-10 blur-3xl" data-id="element-129" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-130">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-131">
          Ready for a <span className="italic font-serif" data-id="element-132">spotless</span> space?
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-133">
          Request a free quote or message us directly on WhatsApp.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-134">
          <Link to="/quote" className="group inline-flex justify-center items-center gap-2 px-8 py-4 rounded-full bg-brand-green text-white font-bold text-lg hover:bg-brand-greenDark transition-all hover:shadow-glow hover:-translate-y-1 w-full sm:w-auto" data-id="element-135">
            Get a Free Quote
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-136" />
          </Link>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center gap-2 px-8 py-4 rounded-full bg-white/10 backdrop-blur-md text-white border-2 border-white/30 font-bold text-lg hover:bg-white hover:text-brand-navy transition-all w-full sm:w-auto" data-id="element-137">
            <MessageCircle className="w-5 h-5" data-id="element-138" />
            WhatsApp Us
          </a>
        </motion.div>
      </div>
    </section>;
}